module.exports = __webpack_public_path__ + "static/suggestions-e2f70edc8bd688644bff9d1f8accb0db.mp4";